import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Message = _resolveComponent("Message")
  const _component_QBEHavingCard = _resolveComponent("QBEHavingCard")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-having-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.QBEHavingDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('qbe.having.title')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_KnFabButton, {
            icon: "fas fa-plus",
            onClick: _ctx.addNewHaving
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Message, {
        class: "p-mx-4",
        severity: "info",
        closable: false,
        style: _ctx.QBEHavingDialogDescriptor.styles.message
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('qbe.having.infoMessage')), 1)
        ]),
        _: 1
      }, 8, ["style"]),
      (_ctx.havings.length === 0)
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 0,
            class: "p-mx-4 p-my-2",
            severity: "info",
            closable: false,
            style: _ctx.QBEHavingDialogDescriptor.styles.message
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('qbe.having.noHavings')), 1)
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.havings, (having) => {
          return (_openBlock(), _createBlock(_component_QBEHavingCard, {
            key: having.filterId,
            propHaving: having,
            entities: _ctx.entities,
            onRemoveHaving: _ctx.removeHaving
          }, null, 8, ["propHaving", "entities", "onRemoveHaving"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}